// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-ZpBewb_9","label":"label-QeZNnEt3"};